/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Product List functionality
define('modules/Product/Product',[
    'jquery',
    'global/all',
    './ProductImage',
    'modules/QuickView/QuickView',
    'modules/AddThis/AddThisLoader',
    'plugins/jquery.matchHeights',
    'plugins/jquery.debouncedresize'
], function ($, Roc, ProductImage, QuickView, AddThisLoader) {
    'use strict';

    var listingMultiView;
    var $productItems;
    var $listing = $('.productList').not('.rocWidget-miniList .productList, .listView, [data-matchHeights=\'false\']');

    function initMatchHeights() {
        equalheight('.container .roc-form-wrapper');
        equalheight('.itemWrapper .productBrand');
        equalheight('#hawkitemlist .itemWrapper .itemImageWrapper');
        equalheight('#hawkitemlist .itemWrapper .itemTitle .itemLink');
        equalheight('#hawkitemlist .itemWrapper .item-brand-id-wrapper');
        equalheight('#hawkitemlist .itemWrapper .itemAction');
    };

    function destroyMatchHeights() {
        $listing.find('.itemWrapper .itemTitle .itemLink').css('min-height', '0');
        $listing.find('.itemWrapper .item-listing-id').css('min-height', '0');
    };

    function resetMatchHeights() {
        destroyMatchHeights();
        initMatchHeights();
    };

    function initSwatches() {
        // listing swatch control, using data-attributes
        $listing.on('click', '.itemWrapper ul.selectionList li', function (e) {
            e.preventDefault();
            var currentItem = $(e.currentTarget).closest('.itemWrapper'),
                currentSwatch = $(e.currentTarget),
                allSwatches = currentSwatch.closest('.selectionList').find('li'),
                newImg = currentSwatch.data().swatchOption,
                attributeId = currentSwatch.closest('.selectionList').data().swatchAttributeId,
                valueId = currentSwatch.data().swatchValueId;

            var params = {
                attributeId: attributeId,
                attributeValueId: valueId
            };

            var $itemLink = currentItem.find('.itemLink');
            var productUrl = $itemLink.first().attr('href');

            var indx = productUrl.indexOf('?');
            if (indx > -1) {
                productUrl = productUrl.substring(0, indx);
            }
            productUrl += '?' + $.param(params);
            $itemLink.attr({ href: productUrl });

            allSwatches.removeClass('active');
            currentSwatch.addClass('active');

            currentItem.find('.itemImageWrapper .itemImage').attr({ src: newImg });
        });
    };

    function multiLayoutSetView(displayMode) {
        var activeControl = $('.roc-pageOptions-filter.listing-display > .listing-display-option[data-display-mode=' + displayMode + ']');

        activeControl.addClass('active').siblings().removeClass('active');

        if (displayMode === 'grid') {
            listingMultiView.removeClass('gridViewAlt listView').addClass('gridView');
            resetMatchHeights();
        }
        else if (displayMode === 'list') {
            listingMultiView.removeClass('gridView gridViewAlt').addClass('listView');
            resetMatchHeights();
        }
        else {
            listingMultiView.removeClass('gridView listView').addClass('gridViewAlt');
            resetMatchHeights();
        };

        Roc.Core.eraseCookie('listingView');
        Roc.Core.createCookie('listingView', displayMode);

        $('body').data('listingView', displayMode);
    };

    function multiLayoutCheckCache() {
        var displayMode = $('body').data('listingView');
        var viewCookie = Roc.Core.getCookie('listingView');

        if (viewCookie !== null) {
            var viewCookieMode = Roc.Core.readCookie('listingView');

            if (viewCookieMode !== displayMode) {
                displayMode = viewCookieMode;
                multiLayoutSetView(displayMode);
            }
        }
    };

    function initMultiLayout() {
        listingMultiView = $('.siteBody .multiLayoutList');

        multiLayoutCheckCache();

        $('.siteBody').on('click', '.roc-pageOptions-filter.listing-display > .listing-display-option', function (e) {
            e.preventDefault();
            var $this = $(e.currentTarget),
                displayMode = $this.data('displayMode');

            multiLayoutSetView(displayMode);
        });

        listingMultiView.on('click', '[data-roc-action="openQuickView"]', function (e) {
            e.preventDefault();
            var id = $(e.currentTarget).closest('.itemWrapper').data('productId');

            QuickView.getProduct(id);
        });
    };

    function init() {
        initMultiLayout();
        ProductImage.initImagesLoaded();

        // if search is insalled set up some overwrites
        if (window.HawkSearch !== undefined && typeof (HawkSearch.jQuery) === 'function') {
            HawkSearch.jQuery('body').on('hawkDebounce', function (e) {
                e.preventDefault();
            }).on('hawkImagesLoaded', function (e) {
                // prevent search's baked in normalize setup
                e.preventDefault();
                // reset heights
                resetMatchHeights();
            }).on('hawkAfterResults', function (e) {
                multiLayoutSetView($('body').data('listingView'));
            });
        };

        $(window).on('debouncedresize', function (e) {
            resetMatchHeights();
        });

        $productItems = $listing.find('.itemWrapper');

        initMatchHeights();
        initSwatches();
    };

    init();

    var Product = {
        init: init,
        resetMatchHeights: resetMatchHeights,
        initSwatches: initSwatches,
    };

    Roc.Logger.debug('Product.js Loaded:', Product);

    return Product;
});
